<template>
  <div class="header-wrapper__wrapper">
    <div class="menu-collapsed-overlay bg-overlay"></div>

    <div
      class="header-wrapper not-scrolled wc"
      @mouseleave="mouse_over_parent($event)"
    >
      <PhoneModal />
      <header class="bg-white header">
        <div class="container">
          <div class="header__row flex a_center j_sb">
            <div class="header__row--left-col flex a_center">
              <router-link :to="get_home_url" class="header__logo">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="194.472"
                  height="30.8"
                  viewBox="0 0 194.472 30.8"
                  v-if="$route.name == 'PageViewRouter_ge'"
                >
                  <g
                    id="Group_5082"
                    data-name="Group 5082"
                    transform="translate(-45.512 -155.645)"
                  >
                    <path
                      id="Path_1281"
                      data-name="Path 1281"
                      d="M121.793,177.322a5,5,0,0,1,.935,3.274v2.941a12.488,12.488,0,0,1-.886,4.846H119.4a14.532,14.532,0,0,0,.8-4.846v-2.923a3.526,3.526,0,0,0-.325-1.772,1.212,1.212,0,0,0-1.113-.518,1.238,1.238,0,0,0-1.135.526,3.44,3.44,0,0,0-.334,1.764V184a4.872,4.872,0,0,1-1.061,3.417,4.093,4.093,0,0,1-3.15,1.145,4,4,0,0,1-3.109-1.153A4.9,4.9,0,0,1,108.927,184v-3.242a5.015,5.015,0,0,1,1.019-3.4,3.745,3.745,0,0,1,2.975-1.161,3.921,3.921,0,0,1,1.972.451,2.443,2.443,0,0,1,1.1,1.32,3.034,3.034,0,0,1,1.194-1.345,3.739,3.739,0,0,1,1.881-.426,3.349,3.349,0,0,1,2.723,1.12m-7.018,3.458a5.334,5.334,0,0,0-.159-1.478,1.28,1.28,0,0,0-.517-.752,1.905,1.905,0,0,0-1.011-.225,1.741,1.741,0,0,0-.962.225,1.279,1.279,0,0,0-.493.752,5.711,5.711,0,0,0-.15,1.478v3.209a5.7,5.7,0,0,0,.15,1.478,1.275,1.275,0,0,0,.493.752,1.735,1.735,0,0,0,.962.226,1.9,1.9,0,0,0,1.011-.226,1.276,1.276,0,0,0,.517-.752,5.321,5.321,0,0,0,.159-1.478Z"
                      transform="translate(-23.168 -7.51)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1282"
                      data-name="Path 1282"
                      d="M141.644,177.354a4.871,4.871,0,0,1,1.062,3.409v2.774a12.477,12.477,0,0,1-.887,4.846h-2.472a14.564,14.564,0,0,0,.8-4.846v-2.758A5.646,5.646,0,0,0,140,179.3a1.284,1.284,0,0,0-.492-.752,2.164,2.164,0,0,0-1.923,0,1.279,1.279,0,0,0-.492.752,5.65,5.65,0,0,0-.15,1.478v2.741a14.8,14.8,0,0,0,.8,4.863h-2.472a12.652,12.652,0,0,1-.887-4.83v-2.791a4.9,4.9,0,0,1,1.052-3.409,4.757,4.757,0,0,1,6.208,0"
                      transform="translate(-32.469 -7.51)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1283"
                      data-name="Path 1283"
                      d="M159.078,184.745q0,3.926-4.193,3.927-4.177,0-4.177-3.927,0-3.44,3.175-3.893v-.669a1,1,0,0,0-.209-.643,5.811,5.811,0,0,0-.728-.694,4.547,4.547,0,0,1-.492-.468,1.508,1.508,0,0,1-.268-.492,2.585,2.585,0,0,1-.109-.827v-.569h2.59v.267a.912.912,0,0,0,.176.577,3.922,3.922,0,0,0,.611.576,2.92,2.92,0,0,1,.752.81,2.177,2.177,0,0,1,.234,1.078v1.153q2.64.65,2.639,3.792m-2.949,1.42a2.823,2.823,0,0,0,0-2.873,1.59,1.59,0,0,0-1.26-.451,1.522,1.522,0,0,0-1.221.451,2.2,2.2,0,0,0-.384,1.438,2.156,2.156,0,0,0,.393,1.436,1.539,1.539,0,0,0,1.228.451,1.56,1.56,0,0,0,1.245-.451"
                      transform="translate(-38.433 -7.616)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1284"
                      data-name="Path 1284"
                      d="M174.5,177.354a4.877,4.877,0,0,1,1.061,3.409v2.774a12.488,12.488,0,0,1-.886,4.846H172.2a14.532,14.532,0,0,0,.8-4.846v-2.758a5.71,5.71,0,0,0-.15-1.478,1.28,1.28,0,0,0-.494-.752,2.16,2.16,0,0,0-1.921,0,1.277,1.277,0,0,0-.494.752,5.716,5.716,0,0,0-.149,1.478v2.741a14.768,14.768,0,0,0,.8,4.863h-2.474a12.688,12.688,0,0,1-.885-4.83v-2.791a4.9,4.9,0,0,1,1.052-3.409,4.757,4.757,0,0,1,6.207,0"
                      transform="translate(-44.473 -7.51)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1285"
                      data-name="Path 1285"
                      d="M184.065,176.491h2.556v8.219a2.1,2.1,0,0,0,.418,1.454,1.765,1.765,0,0,0,1.352.451,1.792,1.792,0,0,0,1.354-.442,2.073,2.073,0,0,0,.417-1.446,2.3,2.3,0,0,0-.124-.769,8.081,8.081,0,0,0-.377-.852,7.554,7.554,0,0,1-.442-1.044,3.352,3.352,0,0,1-.143-1.028v-.25h2.557a3.137,3.137,0,0,0,.142.869,9.353,9.353,0,0,0,.392.968q.285.669.419,1.095a3.5,3.5,0,0,1,.133,1.028q0,3.926-4.328,3.927t-4.326-3.943Z"
                      transform="translate(-50.619 -7.616)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1286"
                      data-name="Path 1286"
                      d="M208.147,177.354a4.88,4.88,0,0,1,1.06,3.409v2.774a12.5,12.5,0,0,1-.885,4.846h-2.473a14.533,14.533,0,0,0,.8-4.846v-2.758a5.711,5.711,0,0,0-.15-1.478,1.279,1.279,0,0,0-.493-.752,2.16,2.16,0,0,0-1.921,0,1.278,1.278,0,0,0-.494.752,5.716,5.716,0,0,0-.149,1.478v2.741a14.769,14.769,0,0,0,.8,4.863h-2.473a12.676,12.676,0,0,1-.885-4.83v-2.791a4.9,4.9,0,0,1,1.052-3.409,4.758,4.758,0,0,1,6.208,0"
                      transform="translate(-56.765 -7.51)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1287"
                      data-name="Path 1287"
                      d="M60.814,172.7c.14,1.453.213,2.209-.965,3.453a39,39,0,0,1-7.437,5.483,32.066,32.066,0,0,1-4.469,2.181c-1.007.363-1.853.517-2.273-.212a1.4,1.4,0,0,1,0-1.283c1.093-2.964,4.245-8.5,6.3-12.1.21-.368.426-.745.648-1.127,3.159-5.453,7.35-12.128,8.174-13.2.119-.155.334-.336.536-.219a.39.39,0,0,1,.142.424c0,.024-.053.22-.072.3a45.134,45.134,0,0,0-.584,16.3"
                      fill="#7063ea"
                    />
                    <path
                      id="Path_1288"
                      data-name="Path 1288"
                      d="M74.86,174.5c-1.328-.605-2.021-.92-2.508-2.563a38.99,38.99,0,0,1-1.03-9.182,31.933,31.933,0,0,1,.347-4.96c.188-1.053.479-1.863,1.32-1.863a1.4,1.4,0,0,1,1.109.645c2.02,2.429,5.235,7.924,7.326,11.5q.321.549.652,1.125c3.143,5.462,6.829,12.43,7.343,13.678.075.181.124.458-.079.574a.389.389,0,0,1-.438-.089c-.018-.016-.164-.155-.221-.211A45.145,45.145,0,0,0,74.86,174.5"
                      transform="translate(-9.43 -0.106)"
                      fill="#7063ea"
                    />
                    <path
                      id="Path_1289"
                      data-name="Path 1289"
                      d="M62.312,189.556c1.188-.848,1.807-1.29,3.473-.89a38.978,38.978,0,0,1,8.466,3.7,31.933,31.933,0,0,1,4.123,2.78c.817.69,1.373,1.347.953,2.075a1.4,1.4,0,0,1-1.113.637c-3.114.535-9.481.572-13.624.595-.424,0-.859,0-1.3,0-6.3-.01-14.178-.3-15.517-.48-.194-.026-.458-.122-.458-.355,0-.189.17-.288.3-.335.022-.008.216-.064.293-.086a45.145,45.145,0,0,0,14.405-7.643"
                      transform="translate(-0.66 -12.009)"
                      fill="#7063ea"
                    />
                    <path
                      id="Path_1290"
                      data-name="Path 1290"
                      d="M230.218,183.216A3.143,3.143,0,0,1,228.952,182a3.642,3.642,0,0,1-.469-1.882v-.28a3.081,3.081,0,0,0-.477-1.924,1.771,1.771,0,0,0-1.463-.591,1.751,1.751,0,0,0-1.512.7,3.977,3.977,0,0,0-.51,2.293,3.854,3.854,0,0,0,1.11,3,7.347,7.347,0,0,0,3.346,1.521,6.473,6.473,0,0,1,2.581,1.175,2.826,2.826,0,0,1,1.1,2.376h-1.266a1.971,1.971,0,0,0-.494-1.349,3.066,3.066,0,0,0-1.29-.845,5.514,5.514,0,0,0-4.316.337l-.461-.889a2.6,2.6,0,0,1,.856-.377,5.212,5.212,0,0,1,1.019-.182,4.124,4.124,0,0,1-1.636-.79,4.631,4.631,0,0,1-1.315-1.627,5.127,5.127,0,0,1-.518-2.353,4.637,4.637,0,0,1,.88-3.083,3.023,3.023,0,0,1,2.425-1.028,2.831,2.831,0,0,1,1.66.453,2.656,2.656,0,0,1,.953,1.34,2.2,2.2,0,0,1,1.044-1.323,3.624,3.624,0,0,1,1.867-.47,3.3,3.3,0,0,1,2.449.963,3.766,3.766,0,0,1,.955,2.77,4.031,4.031,0,0,1-.461,1.972,3.2,3.2,0,0,1-1.248,1.283,3.566,3.566,0,0,1-1.776.444,3.746,3.746,0,0,1-1.767-.419m3.428-1.325a3.875,3.875,0,0,0,0-3.953,2.142,2.142,0,0,0-1.694-.617,2.088,2.088,0,0,0-1.677.617,3.027,3.027,0,0,0-.526,1.981,2.994,2.994,0,0,0,.534,1.98,2.586,2.586,0,0,0,3.362-.008"
                      transform="translate(-64.931 -7.51)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1291"
                      data-name="Path 1291"
                      d="M248.51,176.489v.476a5.01,5.01,0,0,0,.115,1.184,3,3,0,0,0,.378.879,13.654,13.654,0,0,0,.838,1.143q.675.855,1.012,1.38a4.753,4.753,0,0,1,.551,1.317,7.681,7.681,0,0,1,.214,1.972,4.267,4.267,0,0,1-.469,2.063,3.2,3.2,0,0,1-1.3,1.315,3.909,3.909,0,0,1-1.9.453,3.569,3.569,0,0,1-2.655-1,3.755,3.755,0,0,1-1-2.763,4.834,4.834,0,0,1,.823-2.827l1.036.377a5.923,5.923,0,0,0-.4,1.052,5.214,5.214,0,0,0-.156,1.382,3.043,3.043,0,0,0,.551,2.055,2.958,2.958,0,0,0,3.617-.017,3.264,3.264,0,0,0,.551-2.153,6.783,6.783,0,0,0-.155-1.595,3.822,3.822,0,0,0-.437-1.077,14.586,14.586,0,0,0-.887-1.226,12.763,12.763,0,0,1-.962-1.34,4.293,4.293,0,0,1-.477-1.125,5.582,5.582,0,0,1-.157-1.415v-.508Z"
                      transform="translate(-72.626 -7.615)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1292"
                      data-name="Path 1292"
                      d="M263.313,180.888a2.968,2.968,0,0,1,1.652.477,3.242,3.242,0,0,1,1.151,1.34,4.474,4.474,0,0,1,.419,1.981,4.005,4.005,0,0,1-.962,2.862,3.579,3.579,0,0,1-2.737,1.018,3.824,3.824,0,0,1-1.882-.468,3.345,3.345,0,0,1-1.331-1.347,4.2,4.2,0,0,1-.486-2.065,3.987,3.987,0,0,1,.69-2.4,3.572,3.572,0,0,1-1.447-1.151,2.958,2.958,0,0,1-.559-1.808,3.243,3.243,0,0,1,.419-1.67,2.791,2.791,0,0,1,1.126-1.085,3.286,3.286,0,0,1,1.545-.371,3.04,3.04,0,0,1,1.455.355A2.713,2.713,0,0,1,263.823,179a2.353,2.353,0,0,1-.987,1.922c.22-.021.379-.033.477-.033m-3.9-.255a2.951,2.951,0,0,0,1.076.928,5.175,5.175,0,0,1,.838-.559,2.75,2.75,0,0,0,.9-.739,1.825,1.825,0,0,0,.345-1.151,1.879,1.879,0,0,0-.444-1.38,1.664,1.664,0,0,0-1.234-.444,1.852,1.852,0,0,0-1.356.46,2.079,2.079,0,0,0-.469,1.528,2.445,2.445,0,0,0,.338,1.357m5.252,6.173a3.177,3.177,0,0,0,.575-2.137,3.237,3.237,0,0,0-.575-2.17,2.364,2.364,0,0,0-1.841-.641A2.313,2.313,0,0,0,261,182.5a3.273,3.273,0,0,0-.567,2.17,3.177,3.177,0,0,0,.576,2.137,2.914,2.914,0,0,0,3.65,0"
                      transform="translate(-77.566 -7.51)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1293"
                      data-name="Path 1293"
                      d="M276.048,185.107a5.3,5.3,0,0,1,1.019-.181,4.348,4.348,0,0,1-3.469-4.6,4.523,4.523,0,0,1,.9-3.057,3.01,3.01,0,0,1,2.383-1.036,3.172,3.172,0,0,1,1.6.4A2.374,2.374,0,0,1,279.516,178a2.558,2.558,0,0,1,2.68-1.776,3.027,3.027,0,0,1,2.376.962,4.034,4.034,0,0,1,.864,2.786,8.239,8.239,0,0,1-.97,3.783l-1.118-.329a9.5,9.5,0,0,0,.591-1.561,6.844,6.844,0,0,0,.214-1.809,3.39,3.39,0,0,0-.485-2.063,1.835,1.835,0,0,0-1.537-.617,1.757,1.757,0,0,0-1.53.641,3.888,3.888,0,0,0-.46,2.186v1.4h-1.25v-1.4a3.889,3.889,0,0,0-.46-2.186,1.756,1.756,0,0,0-1.529-.641,1.776,1.776,0,0,0-1.512.675,3.848,3.848,0,0,0-.51,2.268,4.36,4.36,0,0,0,.51,2.261,3.318,3.318,0,0,0,1.406,1.291,11.19,11.19,0,0,0,2.376.788,5.871,5.871,0,0,1,2.491,1.218,3.116,3.116,0,0,1,1.028,2.515h-1.266a2.268,2.268,0,0,0-.953-1.964,4.025,4.025,0,0,0-2.4-.682,5.176,5.176,0,0,0-1.242.155,4.541,4.541,0,0,0-1.175.468l-.46-.887a2.579,2.579,0,0,1,.855-.379"
                      transform="translate(-83.33 -7.52)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1294"
                      data-name="Path 1294"
                      d="M295.375,179.245a2.664,2.664,0,0,1,.477-1.537,3.332,3.332,0,0,1,1.266-1.1,3.637,3.637,0,0,1,1.677-.4,3.8,3.8,0,0,1,1.66.379,3.2,3.2,0,0,1,1.266,1.061,2.667,2.667,0,0,1,.478,1.57,2.3,2.3,0,0,1-2.055,2.564,2.815,2.815,0,0,1,1.726.946,3.329,3.329,0,0,1,.658,2.228,3.494,3.494,0,0,1-1,2.68,3.839,3.839,0,0,1-2.729.937,4.572,4.572,0,0,1-1.94-.395,3.147,3.147,0,0,1-1.332-1.1,2.813,2.813,0,0,1-.477-1.613,3.846,3.846,0,0,1,.329-1.512l1.168.23a4.274,4.274,0,0,0-.2,1.266,1.894,1.894,0,0,0,.568,1.521,2.894,2.894,0,0,0,1.882.486,2.586,2.586,0,0,0,1.882-.559,2.724,2.724,0,0,0,.552-1.94,2.875,2.875,0,0,0-.576-1.94,2.352,2.352,0,0,0-1.858-.658h-.641V181.3h.641a2.3,2.3,0,0,0,1.6-.468,2.052,2.052,0,0,0,.5-1.554,1.83,1.83,0,0,0-.567-1.462,2.26,2.26,0,0,0-1.537-.494q-2.122,0-2.121,1.908a3.111,3.111,0,0,0,.131.887l-1.183.23a2.867,2.867,0,0,1-.248-1.1"
                      transform="translate(-91.166 -7.51)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1295"
                      data-name="Path 1295"
                      d="M315.8,176.639a3.292,3.292,0,0,1,1.283,1.241,3.65,3.65,0,0,1,.476,1.891v5.064a3.744,3.744,0,0,1-.97,2.754,3.623,3.623,0,0,1-2.7.978,4.1,4.1,0,0,1-1.908-.426,3.1,3.1,0,0,1-1.266-1.176,3.215,3.215,0,0,1-.444-1.669,3.518,3.518,0,0,1,.444-1.809l1.151.264a4.174,4.174,0,0,0-.3,1.529,2.18,2.18,0,0,0,.552,1.635,2.467,2.467,0,0,0,1.767.536,2.387,2.387,0,0,0,1.874-.609,3.174,3.174,0,0,0,.527-2.072v-4.932a2.689,2.689,0,0,0-.575-1.94,2.255,2.255,0,0,0-1.66-.575q-2.156,0-2.155,1.94a3.979,3.979,0,0,0,.215,1.3l-1.2.263a3.355,3.355,0,0,1-.314-1.513,2.761,2.761,0,0,1,.477-1.578,3.35,3.35,0,0,1,1.275-1.118,3.659,3.659,0,0,1,1.7-.412,3.62,3.62,0,0,1,1.742.436"
                      transform="translate(-96.73 -7.511)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1296"
                      data-name="Path 1296"
                      d="M325.786,179.245a2.672,2.672,0,0,1,.477-1.537,3.331,3.331,0,0,1,1.267-1.1,3.633,3.633,0,0,1,1.677-.4,3.8,3.8,0,0,1,1.66.379,3.2,3.2,0,0,1,1.266,1.061,2.667,2.667,0,0,1,.478,1.57,2.3,2.3,0,0,1-2.055,2.564,2.815,2.815,0,0,1,1.726.946,3.329,3.329,0,0,1,.658,2.228,3.494,3.494,0,0,1-1,2.68,3.839,3.839,0,0,1-2.729.937,4.572,4.572,0,0,1-1.94-.395,3.141,3.141,0,0,1-1.332-1.1,2.809,2.809,0,0,1-.478-1.613,3.847,3.847,0,0,1,.329-1.512l1.168.23a4.255,4.255,0,0,0-.2,1.266,1.892,1.892,0,0,0,.568,1.521,2.893,2.893,0,0,0,1.882.486,2.587,2.587,0,0,0,1.882-.559,2.724,2.724,0,0,0,.552-1.94,2.874,2.874,0,0,0-.576-1.94,2.351,2.351,0,0,0-1.858-.658h-.641V181.3h.641a2.3,2.3,0,0,0,1.6-.468,2.052,2.052,0,0,0,.5-1.554,1.83,1.83,0,0,0-.567-1.462,2.26,2.26,0,0,0-1.537-.494q-2.122,0-2.121,1.908a3.089,3.089,0,0,0,.131.887l-1.184.23a2.866,2.866,0,0,1-.247-1.1"
                      transform="translate(-102.276 -7.51)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1297"
                      data-name="Path 1297"
                      d="M344.613,176.489v.476a4.973,4.973,0,0,0,.116,1.184,3,3,0,0,0,.377.879,13.406,13.406,0,0,0,.839,1.143q.674.855,1.011,1.38a4.733,4.733,0,0,1,.552,1.317,7.742,7.742,0,0,1,.213,1.972,4.26,4.26,0,0,1-.469,2.063,3.187,3.187,0,0,1-1.3,1.315,3.9,3.9,0,0,1-1.9.453,3.566,3.566,0,0,1-2.654-1,3.75,3.75,0,0,1-1-2.763,4.83,4.83,0,0,1,.823-2.827l1.036.377a5.876,5.876,0,0,0-.4,1.052,5.241,5.241,0,0,0-.156,1.382,3.043,3.043,0,0,0,.551,2.055,2.957,2.957,0,0,0,3.616-.017,3.263,3.263,0,0,0,.552-2.153,6.706,6.706,0,0,0-.157-1.595,3.8,3.8,0,0,0-.437-1.077,14.545,14.545,0,0,0-.887-1.226,12.671,12.671,0,0,1-.962-1.34,4.34,4.34,0,0,1-.478-1.125,5.617,5.617,0,0,1-.155-1.415v-.508Z"
                      transform="translate(-107.737 -7.615)"
                      fill="#6d6e70"
                    />
                  </g>
                </svg>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="160.01"
                  height="30.8"
                  viewBox="0 0 160.01 30.8"
                  v-else
                >
                  <g
                    id="Group_5366"
                    data-name="Group 5366"
                    transform="translate(-45.512 -249.767)"
                  >
                    <path
                      id="Path_1298"
                      data-name="Path 1298"
                      d="M114.774,272.916v9.7h-2.752v-9.7h-3.1v-2.26h8.944v2.26Z"
                      transform="translate(-23.168 -7.632)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1299"
                      data-name="Path 1299"
                      d="M129.931,270.656q3.734,0,3.734,3.194a2.776,2.776,0,0,1-.524,1.794,1.992,1.992,0,0,1-1.491.713,2.626,2.626,0,0,1,1.875.786,2.866,2.866,0,0,1,.663,2.014q0,3.458-4.192,3.456h-4.358V270.656Zm.614,4.742a.748.748,0,0,0,.426-.418,3.256,3.256,0,0,0,0-1.769.747.747,0,0,0-.426-.418,2.482,2.482,0,0,0-.892-.123h-1.36v2.851h1.343a2.547,2.547,0,0,0,.909-.123m.27,5.021a.845.845,0,0,0,.508-.459,3.231,3.231,0,0,0,0-1.933.849.849,0,0,0-.516-.459,3.382,3.382,0,0,0-1.073-.131h-1.441v3.112h1.441a3.353,3.353,0,0,0,1.081-.131"
                      transform="translate(-29.274 -7.632)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1300"
                      data-name="Path 1300"
                      d="M142.664,281.16a6.735,6.735,0,0,1-1.359-4.6q0-6.158,5.454-6.159a7.627,7.627,0,0,1,2.524.393l-.508,2.195a3.891,3.891,0,0,0-1.852-.41,3.686,3.686,0,0,0-1.761.336,1.87,1.87,0,0,0-.843,1.18,12.526,12.526,0,0,0-.009,4.9,1.8,1.8,0,0,0,.836,1.154,3.656,3.656,0,0,0,1.728.328,4.191,4.191,0,0,0,2.146-.508l.492,2.244a7.414,7.414,0,0,1-2.753.475,5.206,5.206,0,0,1-4.095-1.524"
                      transform="translate(-34.997 -7.537)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1301"
                      data-name="Path 1301"
                      d="M60.814,266.822c.14,1.453.213,2.209-.965,3.453a39,39,0,0,1-7.437,5.483,32.069,32.069,0,0,1-4.469,2.181c-1.007.363-1.853.516-2.273-.212a1.4,1.4,0,0,1,0-1.283c1.093-2.964,4.245-8.5,6.3-12.1.21-.368.426-.745.648-1.127,3.159-5.453,7.35-12.128,8.174-13.2.119-.155.334-.336.536-.219a.39.39,0,0,1,.142.424c0,.024-.053.22-.072.3a45.134,45.134,0,0,0-.584,16.3"
                      fill="#7063ea"
                    />
                    <path
                      id="Path_1302"
                      data-name="Path 1302"
                      d="M74.86,268.626c-1.328-.605-2.021-.92-2.508-2.563a38.99,38.99,0,0,1-1.03-9.182,31.932,31.932,0,0,1,.347-4.96c.188-1.053.479-1.863,1.32-1.863a1.4,1.4,0,0,1,1.109.644c2.02,2.429,5.235,7.924,7.326,11.5q.321.549.652,1.125c3.143,5.462,6.829,12.43,7.343,13.678.075.181.124.458-.079.574a.389.389,0,0,1-.438-.089c-.018-.016-.164-.155-.221-.211a45.145,45.145,0,0,0-13.822-8.654"
                      transform="translate(-9.43 -0.106)"
                      fill="#7063ea"
                    />
                    <path
                      id="Path_1303"
                      data-name="Path 1303"
                      d="M62.312,283.678c1.188-.848,1.807-1.29,3.473-.89a38.978,38.978,0,0,1,8.466,3.7,31.935,31.935,0,0,1,4.123,2.78c.817.69,1.373,1.347.953,2.075a1.4,1.4,0,0,1-1.113.638c-3.114.535-9.481.572-13.624.595-.424,0-.859,0-1.3,0-6.3-.009-14.178-.3-15.517-.48-.194-.026-.458-.122-.458-.355,0-.188.17-.287.3-.334.022-.008.216-.064.293-.086a45.144,45.144,0,0,0,14.405-7.643"
                      transform="translate(-0.66 -12.009)"
                      fill="#7063ea"
                    />
                    <rect
                      id="Rectangle_987"
                      data-name="Rectangle 987"
                      width="1.326"
                      height="11.958"
                      transform="translate(121.079 263.024)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1304"
                      data-name="Path 1304"
                      d="M172.639,270.656l6.125,9.4v-9.4h1.23v11.958h-1.048l-6.143-9.4v9.4h-1.229V270.656Z"
                      transform="translate(-46.056 -7.632)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1305"
                      data-name="Path 1305"
                      d="M188.453,282.042l.263-1.18a7.02,7.02,0,0,0,3.1.688,4.677,4.677,0,0,0,1.54-.2,1.32,1.32,0,0,0,.77-.663,3.166,3.166,0,0,0,.229-1.352,2.05,2.05,0,0,0-.213-1.031,1.926,1.926,0,0,0-.737-.656,18.876,18.876,0,0,0-1.835-.835,8.974,8.974,0,0,1-1.679-.845,2.836,2.836,0,0,1-.925-.991,3,3,0,0,1-.31-1.441q0-3.144,3.472-3.146a7.017,7.017,0,0,1,3,.625l-.279,1.194a5,5,0,0,0-2.652-.687,4.222,4.222,0,0,0-1.376.173,1.149,1.149,0,0,0-.68.6,2.868,2.868,0,0,0-.2,1.212,2.072,2.072,0,0,0,.221,1.049,1.826,1.826,0,0,0,.737.654q.516.278,1.793.8a9.979,9.979,0,0,1,1.738.852,2.722,2.722,0,0,1,.925.967,2.885,2.885,0,0,1,.3,1.393q0,3.455-3.85,3.455a8.339,8.339,0,0,1-3.342-.638"
                      transform="translate(-52.223 -7.536)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1306"
                      data-name="Path 1306"
                      d="M203.553,278.485v-7.829h1.295v7.829a5.833,5.833,0,0,0,.237,1.9,1.543,1.543,0,0,0,.818.925,5.325,5.325,0,0,0,3.358,0,1.55,1.55,0,0,0,.82-.925,5.869,5.869,0,0,0,.237-1.9v-7.829h1.261v7.829q0,4.293-4,4.291-4.032,0-4.03-4.291"
                      transform="translate(-57.739 -7.632)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1307"
                      data-name="Path 1307"
                      d="M224.823,270.656q3.6,0,3.6,3.406a3.014,3.014,0,0,1-2.9,3.342l3.326,5.209h-1.524l-3.178-5.127H222.4v5.127H221.1V270.656Zm1.4,5.586a1.3,1.3,0,0,0,.729-.721,3.931,3.931,0,0,0,.212-1.458,3.8,3.8,0,0,0-.212-1.433,1.268,1.268,0,0,0-.729-.7,4.111,4.111,0,0,0-1.467-.206h-2.391v4.734h2.375a4.052,4.052,0,0,0,1.483-.212"
                      transform="translate(-64.152 -7.632)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1308"
                      data-name="Path 1308"
                      d="M237.554,279.712l-.983,2.9H235.2l4.291-11.958h1.229l4.292,11.958H243.6l-.967-2.9Zm2.539-7.55-2.18,6.453h4.342Z"
                      transform="translate(-69.3 -7.631)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1309"
                      data-name="Path 1309"
                      d="M255.05,270.656l6.126,9.4v-9.4H262.4v11.958h-1.048l-6.143-9.4v9.4h-1.229V270.656Z"
                      transform="translate(-76.164 -7.632)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1310"
                      data-name="Path 1310"
                      d="M271.175,276.572a7.237,7.237,0,0,1,1.253-4.635,4.6,4.6,0,0,1,3.792-1.541,5.646,5.646,0,0,1,2.277.411l-.263,1.13a4.4,4.4,0,0,0-1.965-.411,4.868,4.868,0,0,0-2.31.442,2.472,2.472,0,0,0-1.139,1.514,10.907,10.907,0,0,0-.336,3.089,10.548,10.548,0,0,0,.336,3.038,2.438,2.438,0,0,0,1.13,1.49,4.878,4.878,0,0,0,2.3.435,4.489,4.489,0,0,0,2.229-.506l.245,1.178a6.065,6.065,0,0,1-2.521.475q-5.029,0-5.03-6.109"
                      transform="translate(-82.444 -7.537)"
                      fill="#6d6e70"
                    />
                    <path
                      id="Path_1311"
                      data-name="Path 1311"
                      d="M293.652,282.613h-6.914V270.656h6.75v1.1h-5.455v4.227h4.98v1.1h-4.98v4.407h5.619Z"
                      transform="translate(-88.13 -7.631)"
                      fill="#6d6e70"
                    />
                  </g>
                </svg>
              </router-link>
              <div
                class="header__cat--wrapper flex a_center"
                v-if="windowWidth >= 1366"
              >
                <router-link
                  :to="cat.full_url"
                  class="header__cat flex a_center pointer"
                  v-for="(cat, index) in grand_parents"
                  :key="index"
                  @mouseenter.native="collapse_menu(cat, $event)"
                  @mouseleave="uncollapse_menu(cat, $event)"
                >
                  <h2
                    class="bold f-14 uppercase"
                    v-if="$route.name == 'PageViewRouter_ge'"
                  >
                    {{ cat.titles.ge.title }}
                  </h2>
                  <h2 class="bold f-14 uppercase" v-else>
                    {{ cat.titles.en.title }}
                  </h2>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10.492"
                    height="6.246"
                    viewBox="0 0 10.492 6.246"
                  >
                    <path
                      id="Path"
                      d="M0,0,3.832,3.832,7.664,0"
                      transform="translate(1.414 1.414)"
                      fill="none"
                      stroke="#000"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-miterlimit="10"
                      stroke-width="2"
                    />
                  </svg>
                </router-link>
              </div>
            </div>
            <div class="header__row--right-col flex a_center">
              <router-link
                :to="get_search_url"
                class="header__row--search-btn  pointer"
                v-if="windowWidth >= 768"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23.84"
                  height="23.84"
                  viewBox="0 0 23.84 23.84"
                >
                  <g
                    id="Group_3358"
                    data-name="Group 3358"
                    transform="translate(-1035.408 -60.287)"
                  >
                    <g
                      id="Group_3167"
                      data-name="Group 3167"
                      transform="translate(1036.408 61.287)"
                    >
                      <path
                        id="Path_1243"
                        data-name="Path 1243"
                        d="M9.374,18.748A9.374,9.374,0,1,0,0,9.374,9.374,9.374,0,0,0,9.374,18.748Zm12.052,2.678-5.356-5.356"
                        fill="none"
                        stroke="#7063e9"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                    </g>
                  </g>
                </svg>
              </router-link>

              <a
                :href="_.get(my_space, 'url')"
                target="_blank"
                class="header__row--personal-space button bg-light-purple  pointer"
              >
                <span
                  class="f-14 bold f-white uppercase"
                  v-if="windowWidth >= 1366"
                  >{{ _.get(my_space, 'title') }}</span
                >
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  width="23.986"
                  height="23.635"
                  viewBox="0 0 23.986 23.635"
                >
                  <g id="profile" transform="translate(-11.436 -13)">
                    <circle
                      id="Ellipse_191"
                      data-name="Ellipse 191"
                      cx="5.598"
                      cy="5.598"
                      r="5.598"
                      transform="translate(17.831 13)"
                      fill="#7063e9"
                    />
                    <path
                      id="Path_2836"
                      data-name="Path 2836"
                      d="M11.456,63.739a1.6,1.6,0,0,0,1.586,1.835H33.816A1.588,1.588,0,0,0,35.4,63.739C34.5,58.172,29.493,55,23.429,55S12.358,58.172,11.456,63.739Z"
                      transform="translate(0 -28.939)"
                      fill="#7063e9"
                    />
                  </g>
                </svg>
              </a>

              <div
                class="header__row--phone br-6 pointer flex a_center j_center button mr-30"
                v-if="windowWidth >= 1366"
                @click="
                  $store.state.main.phone_modal = !$store.state.main.phone_modal
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                >
                  <path
                    id="Path"
                    d="M19.936,14.638a4.266,4.266,0,0,0-.185-.73,1,1,0,0,0-.72-.647l-5.964-1.369a1.007,1.007,0,0,0-.916.253c-.143.137-.146.14-.8,1.382a9.927,9.927,0,0,1-4.88-4.883c1.239-.649,1.243-.652,1.38-.8a1,1,0,0,0,.253-.916L6.739.969a1,1,0,0,0-.647-.72A4.233,4.233,0,0,0,5.365.065,4.488,4.488,0,0,0,4.6,0,4.6,4.6,0,0,0,0,4.6,15.418,15.418,0,0,0,15.4,20a4.6,4.6,0,0,0,4.535-5.362"
                    fill="#7063e9"
                  />
                </svg>
              </div>

              <router-link
                :to="$store.state.main.selected_menu_locales.en"
                v-if="$route.name == 'PageViewRouter_ge' && windowWidth >= 768"
                class="f-14 medium f-gray"
                >Eng</router-link
              >
              <router-link
                :to="$store.state.main.selected_menu_locales.ge"
                v-if="$route.name == 'PageViewRouter_en' && windowWidth >= 768"
                class="f-14 medium f-gray"
                >ქართ</router-link
              >

              <div
                class="header__row--burger-icon button ml-30 flex column j_sb wc"
                v-if="windowWidth <= 1365"
                :class="{ active: burger_open }"
                @click="burger_toggle"
              >
                <span class="wc"></span>
                <span class="wc"></span>
                <span class="wc"></span>
              </div>
            </div>
          </div>
        </div>
      </header>

      <slide-up-down
        :active="clicked_parent_id === cat.id"
        :duration="500"
        class="header__cat__collapsed bg-white"
        v-for="(cat, index) in grand_parents"
        :key="index + 'D'"
      >
        <div class="header__cat__collapsed--overlay"></div>
        <div class="header__cat__collapsed--inner container flex">
          <div class="header__cat__collapsed--left-col flex">
            <div
              class="header__cat__collapsed--cat flex column"
              v-for="(sub_cat, index) in clicked_parent_child"
              :key="index"
            >
              <h2 class="f-18 bold">
                {{
                  $route.name == "PageViewRouter_ge"
                    ? sub_cat.titles.ge.title
                    : sub_cat.titles.en.title
                }}
              </h2>
              <router-link
                :to="child.full_url"
                v-for="(child, index) in sub_cat.children"
                :key="index + 'A'"
                ><h3 class="f-14 medium">
                  {{
                    $route.name == "PageViewRouter_ge"
                      ? child.titles.ge.title
                      : child.titles.en.title
                  }}
                </h3>
              </router-link>
            </div>
          </div>

          <div
            class="header__cat__collapsed--banner bg-light-purple br-12 flex column"
            :style="{backgroundColor: cat.titles.colorPallete.bgColor}"
            v-if="cat.media.banner_image"
          >
          
            <img :src="cat.media.banner_image.url" alt="" />
            <h2 class="bold f-28 f-white uppercase">
              {{
                $route.name == "PageViewRouter_ge"
                  ? cat.titles.ge.banner.title
                  : cat.titles.en.banner.title
              }}
            </h2>

            <div
              class="button bg-white flex j_center a_center pointer"
              @click="
                $store.state.main.download_modal = !$store.state.main
                  .download_modal
              "
            >
              <svg
                id="Group_5_Copy_3"
                data-name="Group 5 Copy 3"
                xmlns="http://www.w3.org/2000/svg"
                width="11.352"
                height="11.352"
                viewBox="0 0 11.352 11.352"
              >
                <path
                  id="Combined_Shape_Copy_2"
                  data-name="Combined Shape Copy 2"
                  d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
                  fill="#7063e9"
                />
              </svg>

              <span class="f-14 bold f-light-purple uppercase">{{
                $route.name == "PageViewRouter_ge"
                  ? cat.titles.ge.banner.url_title
                  : cat.titles.en.banner.url_title
              }}</span>
            </div>
          </div>
        </div>
      </slide-up-down>

      <transition name="burger_anim">
        <div class="header__burger--collapsed bg-white wc" v-if="burger_open">
          <div class="header__burger--inner flex column container">
            <div
              class="header__burger--row__lang flex a_center"
              v-if="windowWidth <= 767"
            >
              <span class="f-14 regular f-gray"
                >{{ $fn.tr("ენის ცვლილება") }}:</span
              >

              <router-link
                :to="
                  $route.name == 'PageViewRouter_ge'
                    ? $store.state.main.selected_menu_locales.en
                    : $route
                "
                v-if="windowWidth <= 767"
                class="f-14 medium f-gray"
                :class="{ active: $route.name == 'PageViewRouter_en' }"
                >Eng</router-link
              >
              &nbsp; <span class="f-light-purple"> /</span> &nbsp;
              <router-link
                :to="
                  $route.name == 'PageViewRouter_en'
                    ? $store.state.main.selected_menu_locales.ge
                    : $route
                "
                v-if="windowWidth <= 767"
                class="f-14 medium f-gray"
                :class="{ active: $route.name == 'PageViewRouter_ge' }"
                >ქართ</router-link
              >
            </div>
            <router-link
              :to="get_search_url"
              class="header__burger--search"
              v-if="windowWidth <= 767"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="23.84"
                height="23.84"
                viewBox="0 0 23.84 23.84"
              >
                <g
                  id="Group_5467"
                  data-name="Group 5467"
                  transform="translate(-1035.408 -60.287)"
                >
                  <g
                    id="Group_3167"
                    data-name="Group 3167"
                    transform="translate(1036.408 61.287)"
                  >
                    <path
                      id="Path_1243"
                      data-name="Path 1243"
                      d="M9.374,18.748A9.374,9.374,0,1,0,0,9.374,9.374,9.374,0,0,0,9.374,18.748Zm12.052,2.678-5.356-5.356"
                      fill="none"
                      stroke="#7063e9"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    />
                  </g>
                </g>
              </svg>

              <el-input
                :placeholder="$fn.tr('საძიებო სიტყვა')"
                v-model="search_input"
                disabled
              ></el-input>
            </router-link>

            <div class="header__burger--menu__titles flex">
              <router-link
                :to="cat.full_url"
                :class="{ active: active_menu_sm == cat.id }"
                v-for="(cat, index) in grand_parents"
                :key="index"
              >
                <h2 class="f-14 bold f-gray uppercase">
                  {{
                    $route.name == "PageViewRouter_ge"
                      ? cat.titles.ge.title
                      : cat.titles.en.title
                  }}
                </h2>
              </router-link>
            </div>

            <div class="header__burger--menu__collapsed flex column">
              <div
                class="header__burger--menu__col flex column"
                v-for="(item, index) in this.sub_menus_sm"
                :key="index"
              >
                <h2 class="f-18 bold">
                  {{
                    $route.name == "PageViewRouter_ge"
                      ? item.parent.titles.ge.title
                      : item.parent.titles.en.title
                  }}
                </h2>
                <router-link
                  :to="child.full_url"
                  class="f-14 medium"
                  v-for="(child, index) in item.children"
                  :key="index + 'N'"
                >
                  {{
                    $route.name == "PageViewRouter_ge"
                      ? child.titles.ge.title
                      : child.titles.en.title
                  }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import PhoneModal from "@/components/modals/Phone";
import resize from "@/mixins/resize_handler";
import fix_100_vh_android from "@/mixins/fix_100_vh_android";
export default {
  components: {
    PhoneModal
  },
  mixins: [resize, fix_100_vh_android],
  data() {
    return {
      clicked_parent_id: null,
      clicked_parent_child: null,
      burger_open: false,
      active_menu_sm: 0,
      sub_menus_sm: "",
      search_input: "",
      time_out: ""
    };
  },
  created() {
     if(_.get(this.$store, 'state.main.selected_menu.id')){
    this.check_for_parent_sm();

    }
  },
  mounted() {
    if (this.windowWidth <= 1365) {
      this.fix_vh_android();
      window.addEventListener("resize", () => {
        this.fix_vh_android();
      });
    }
  },
  computed: {
    get_home_url() {
      let menus = this.$store.state.main.indx.menus;
      menus = menus.filter(m => m.set_home == 1);
      return menus[0].full_url;
    },
    get_search_url() {
      let menus = this.$store.state.main.indx.menus;
      menus = menus.filter(m => m.configs.includes("search"));
      return menus[0].full_url;
    },
    my_space() {
      return this.$store.state.main.indx.widgets.myspace.myspace;
    },

    grand_parents() {
      let menus = this.$store.state.main.indx.menus;
      menus = menus.filter(m => !m.configs.includes("disable-from-menu"));

      let gp = menus.filter(m => m.pid == 0);
      return gp;
    },

    selected_menu() {
      return this.$store.state.main.selected_menu;
    }
  },

  methods: {
    check_for_parent_sm() {
      let slctd = this.$store.state.main.selected_menu;

      let mains = false;

      if (slctd.configs.includes("main_parent")) mains = true;

      if (this.windowWidth <= 1365) {
        if (mains) {
          if (slctd.pid == 0) {
            let grand_parent = this.grand_parents.filter(
              parent => parent.id == slctd.id
            );

            this.active_menu_sm = grand_parent[0].id;
            this.collapse_menu_sm(grand_parent[0]);
          } else {
            let menus = this.$store.state.main.indx.menus;
            let _menu = menus.filter(m => m.id == slctd.pid);
            let grand_parent = this.grand_parents.filter(
              parent => parent.id == _menu[0].pid
            );

            this.active_menu_sm = grand_parent[0].id;
            this.collapse_menu_sm(grand_parent[0]);
          }
        } else {
          this.active_menu_sm = this.grand_parents[0].id;
          this.collapse_menu_sm(this.grand_parents[0]);
        }
      }
    },
    set_collapsed_menu_height_sm() {
      if (this.windowWidth <= 1365) {
        let menu = document.querySelector(".header__burger--menu__collapsed");
        menu.style.height = `${this.windowHeight -
          menu.getBoundingClientRect().top -
          30}px`;
      }
    },
    collapse_menu_sm(cat, idx) {
      let menus = this.$store.state.main.indx.menus;
      menus = menus.filter(m => !m.configs.includes("disable-from-menu"));
      let sub_menus;
      let sub_menus_children = [];
      sub_menus = menus.filter(m => m.pid === cat.id);
      for (let j = 0; j < sub_menus.length; j++) {
        let _m = menus.filter(m => m.pid === sub_menus[j].id);
        let __m = {
          parent: sub_menus[j],
          children: _m.filter(
            child => !child.configs.includes("hide-from-header")
          )
        };
        sub_menus_children.push(__m);
      }
      this.sub_menus_sm = sub_menus_children;
    },

    burger_toggle() {
      this.burger_open = !this.burger_open;
    },
    collapse_menu(parent, event) {
      let current_target = event.currentTarget;

      let menus = this.$store.state.main.indx.menus;
      menus = menus.filter(m => !m.configs.includes("disable-from-menu"));
      let sub_parent;
      let branch = {};

      if (
        this.clicked_parent_id !== parent.id &&
        this.clicked_parent_id !== null
      ) {
        this.clicked_parent_id = null;
        this.time_out = setTimeout(() => {
          this.clicked_parent_id = parent.id;
          sub_parent = menus.filter(m => m.pid == parent.id);
          branch = sub_parent;

          branch.forEach(b => {
            b.children = menus.filter(
              m => m.pid == b.id && !m.configs.includes("hide-from-header")
            );
          });
          this.clicked_parent_child = branch;
          if (document.querySelector(".active-cat"))
            document
              .querySelector(".active-cat")
              .classList.remove("active-cat");
          current_target.classList.add("active-cat");
        }, 590);
      } else if (this.clicked_parent_id == parent.id) {
        sub_parent = menus.filter(m => m.pid == parent.id);
        branch = sub_parent;

        branch.forEach(b => {
          b.children = menus.filter(
            m => m.pid == b.id && !m.configs.includes("hide-from-header")
          );
        });


        this.clicked_parent_child = branch;
      } else {
        this.clicked_parent_id = parent.id;
        sub_parent = menus.filter(m => m.pid == parent.id);
        branch = sub_parent;

        branch.forEach(b => {
          b.children = menus.filter(
            m => m.pid == b.id && !m.configs.includes("hide-from-header")
          );
        });

        this.clicked_parent_child = branch;

        if (document.querySelector(".active-cat"))
          document.querySelector(".active-cat").classList.remove("active-cat");
        current_target.classList.add("active-cat");
      }

      document.querySelector(".menu-collapsed-overlay").style.opacity = "0.5";
    },
    mouse_over_parent(ev) {
      this.clicked_parent_id = null;
      if (document.querySelector(".active-cat"))
        document.querySelector(".active-cat").classList.remove("active-cat");
      document.querySelector(".menu-collapsed-overlay").style.opacity = "0";
    },
    uncollapse_menu(parent, event) {
      clearTimeout(this.time_out);
      document.querySelector(".menu-collapsed-overlay").style.opacity = "0";
    }
  },
  watch: {
    $route() {
      document.querySelector(".menu-collapsed-overlay").style.opacity = "0";

      this.clicked_parent_id = null;

      if (document.querySelector(".active-cat"))
        document.querySelector(".active-cat").classList.remove("active-cat");
      this.check_for_parent_sm();

      if (this.windowWidth <= 1365) {
        if (this.burger_open) this.burger_open = !this.burger_open;
      }
    },
    burger_open(ns, os) {
      ns == true
        ? document.querySelector("body").classList.add("modal-open")
        : document.querySelector("body").classList.remove("modal-open");
      ns == true
        ? document.querySelector("html").classList.add("modal-open")
        : document.querySelector("html").classList.remove("modal-open");
      ns == true
        ? document
            .querySelector(".header-wrapper.not-scrolled")
            .classList.add("modal-open")
        : document
            .querySelector(".header-wrapper.not-scrolled")
            .classList.remove("modal-open");
      ns == true
        ? document
            .querySelector(".header-wrapper.not-scrolled")
            .classList.add("mob__100")
        : document
            .querySelector(".header-wrapper.not-scrolled")
            .classList.remove("mob__100");
      ns == true
        ? (this.$store.state.main.stop_scroll = true)
        : (this.$store.state.main.stop_scroll = false);

      window.scrollTo(0, 1);
      if (ns == false)
        document
          .querySelector(".header-wrapper.not-scrolled")
          .removeAttribute("style");
      if (ns == true) this.fix_vh_android();
      setTimeout(() => {
        this.set_collapsed_menu_height_sm();
      }, 10);
    },
    clicked_parent_id(ns, os) {
      ns == null
        ? (document.querySelector(".menu-collapsed-overlay").style.opacity =
            "0")
        : (document.querySelector(".menu-collapsed-overlay").style.opacity =
            "0.5");
    }
  }
};
</script>
<style lang="sass">
.menu-collapsed-overlay.bg-overlay
  transition: .3s
  pointer-events: none
  z-index: 2
</style>
